import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  ArcElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Card, CardBody, CardHeader } from "../../../components/card/card";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ dataSource }) {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        position: "right",
      },
    },
  };
  const [data, setData] = useState(null);
  const colors = ["#d9534f", "#f0ad4e", themeColor];
  const [dataChart, setDataChart] = useState([
    {
      priority: "High",
      count: 0,
    },
    {
      priority: "Medium",
      count: 0,
    },
    {
      priority: "Low",
      count: 0,
    },
  ]);

  // labels will be the date of data source if it exist only one date in the label
  useEffect(() => {
    if (dataSource) {
      const labels = ["High", "Medium", "Low"];

      const datasets = [];
      const datas = [];
      const tmp = [...dataChart];
      const high = dataSource.find(
        (item) => item.priority.toLowerCase() === "high"
      );
      const medium = dataSource.find(
        (item) => item.priority.toLowerCase() === "medium"
      );
      const low = dataSource.find(
        (item) => item.priority.toLowerCase() === "low"
      );
      if (high) {
        datas.push(high.count);
        tmp[0].count = high.count;
      } else {
        datas.push(0);
      }
      if (medium) {
        datas.push(medium.count);
        tmp[1].count = medium.count;
      } else {
        datas.push(0);
      }
      if (low) {
        datas.push(low.count);
        tmp[2].count = low.count;
      } else {
        datas.push(0);
      }
      datasets.push({
        label: "# of Work Orders",
        data: datas,
        backgroundColor: colors,
        borderColor: colors,
      });
      setDataChart(tmp);

      const data = {
        labels,
        datasets: datasets,
      };
      setData(data);
    }
  }, [dataSource]);

  return (
    <div className="row">
      <div className="col-12">
        <Card className="border-theme mb-3">
          <CardBody>
            <div>
              <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50 text-center">
                Priority
              </div>
              <div className="chart mb-2" style={{ height: "400px" }}>
                {data ? (
                  <div
                    style={{
                      position: "relative",
                      height: "370px",
                      width: "100%",
                    }}
                  >
                    <Doughnut
                      style={{ margin: "auto" }}
                      data={data}
                      options={options}
                    />
                  </div>
                ) : (
                  <div>
                    <div className="spinner-grow text-primary"></div>
                  </div>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
export default App;
